export const media = {
    mobile: '@media(max-width: 768px)',
    tablet: '@media(min-width: 769px) and (max-width: 1024px)',
    desktop: '@media(min-width: 1025px)',
  };